import * as AT from "./authTypes";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_ENDPOINT
  ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "")
  : "";

const AUTH_URL     = API_BASE + "/rest/user/authenticate";
const VALIDATE_URL = API_BASE + "/rest/user/validate";

export const authenticateUser = (email, password) => async (dispatch) => {
  dispatch(loginRequest());
  try {
    const response = await axios.post(AUTH_URL, {
      email: email,
      password: password,
    });
    
    const { token, name, role, email: userEmail } = response.data;
    
    localStorage.setItem("jwtToken", token);
    
    // Set default auth header for all future requests
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    dispatch(success({ 
      username: name, 
      email: userEmail,
      role: role,
      isLoggedIn: true 
    }));
    
    return Promise.resolve(response.data);
  } catch (error) {
    dispatch(failure());
    return Promise.reject(error);
  }
};

export const validateToken = () => async (dispatch) => {
  const token = localStorage.getItem("jwtToken");
  
  if (!token) {
    dispatch(failure());
    return Promise.reject("No token found");
  }
  
  try {
    const response = await axios.get(VALIDATE_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    if (response.data.valid) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      dispatch(success({
        username: response.data.name,
        email: response.data.email,
        role: response.data.role,
        isLoggedIn: true
      }));
      return Promise.resolve(response.data);
    } else {
      dispatch(failure());
      localStorage.removeItem("jwtToken");
      return Promise.reject("Token invalid");
    }
  } catch (error) {
    dispatch(failure());
    localStorage.removeItem("jwtToken");
    return Promise.reject(error);
  }
};

export const logoutUser = () => {
  return (dispatch) => {
    dispatch(logoutRequest());
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("authState");
    delete axios.defaults.headers.common['Authorization'];
    dispatch(success({ username: "", email: "", role: "", isLoggedIn: false }));
  };
};

// Initialize axios with token if exists
export const initializeAuth = () => {
  const token = localStorage.getItem("jwtToken");
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
};

const loginRequest = () => {
  return {
    type: AT.LOGIN_REQUEST,
  };
};

const logoutRequest = () => {
  return {
    type: AT.LOGOUT_REQUEST,
  };
};

const success = (payload) => {
  return {
    type: AT.SUCCESS,
    payload: payload,
  };
};

const failure = () => {
  return {
    type: AT.FAILURE,
    payload: false,
  };
};
